export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-Direct-Message-53cb49da77daaa578bc9b2fb2c970663.png";